import Accordian from "react-bootstrap/Accordion";
import Tabs from 'react-bootstrap/Tabs'
import Card from "react-bootstrap/Card";
import { useAccordionButton } from "react-bootstrap";
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
export default function Faqs() {
  return (
     <section
      className="faq padding-top padding-bottom bg--primary-color py-5"
      id="faq">
      <div className="container">
      <div className="section-header section-header--middle">
          <div className="section-header__content">
            <div className="section-header__titlebar">
              <p className="section-header__subtitle"> Faq</p>
              <h2 className="section__header__title"> Common Questions</h2>
            </div>
          </div>
        </div>
        {/* <!-- Navigation --> */}
        <div
          className="faq__wrapper"
         
        >
          <Tab.Container id="pills-tab" className="faq__tab nav nav-pills mb-5" defaultActiveKey="first">
            <Row>
            <Col lg={3}></Col>
              <Col lg={6} className="faq__tab mb-5">
          <Nav className="faq__tab">
            <Nav.Item>
              <Nav.Link eventKey="first">General Questions</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="second">Rewards System</Nav.Link>
            </Nav.Item>
          </Nav>
          </Col>
          <Col lg={3}></Col>
          </Row>
          <Row>
            <Col lg={12}>
            <Tab.Content>
            <Tab.Pane eventKey="first">
            <div className="row gy-3 gx-0">
                <div className="col-lg-6">
                  <Accordian  id="accordionGeneral1">
                    <Accordian.Item eventKey="0">
                      <Accordian.Header>What is Quantum Energy?</Accordian.Header>
                      <Accordian.Body>
                        Quantum Energy ($QTE) is a new ERC-20 token created for the Ethereum
                        blockchain. $QTE was created by veterans in crypto who strive to
                        build projects that are safe to invest in and built to grow far past
                        day 1.
                      </Accordian.Body>
                    </Accordian.Item>
                    <Accordian.Item eventKey="1">
                      <Accordian.Header>Were there team tokens?</Accordian.Header>
                      <Accordian.Body>
                        No, the Quantum Energy launch had no team tokens destributed or outside investor liquidity. All liquidity was provided by the team. We aped at launch just like everyone else.
                      </Accordian.Body>
                    </Accordian.Item>
                    <Accordian.Item eventKey="2">
                      <Accordian.Header>Why is this safe to invest in?</Accordian.Header>
                      <Accordian.Body>
                        We provide safety by locking our liquidity up for
                        periods of time that increases as our market cap does. The contract is not renounced to allow us to continue to add features and new dapps. Once the reward system has completed, we will renounce the contract.
                      </Accordian.Body>
                    </Accordian.Item>
                    <Accordian.Item eventKey="3">
                      <Accordian.Header>Is there a transfer tax?</Accordian.Header>
                      <Accordian.Body>
                        No, there is not a transfer tax on wallet to wallet transfers.
                      </Accordian.Body>
                    </Accordian.Item>
                  </Accordian>
                </div>
                <div className="col-lg-6">
                  <Accordian id="accordionGeneral2">
                    <Accordian.Item eventKey="0">
                      <Accordian.Header>What are the taxes?</Accordian.Header>
                      <Accordian.Body>
                        <p>At launch, we will set a buy tax at 1% and sell tax at
                          99% to discourage bots from front running everyone.
                          After the first hour, we will keep the buy tax at 1%
                          and reduce sell tax to 5%.</p>
                        <p>Ultimately the taxes will be 1% buy and sell.</p>
                      </Accordian.Body>
                    </Accordian.Item>
                    <Accordian.Item eventKey="1">
                      <Accordian.Header>Where do taxes go?</Accordian.Header>
                      <Accordian.Body>
                        <p> On buys, the 1% tax goes towards liquidity. On sells,
                          the 1% tax goes towards development and marketing.</p>
                      </Accordian.Body>
                    </Accordian.Item>
                    <Accordian.Item eventKey="2">
                      <Accordian.Header>How do the rewards work?</Accordian.Header>
                      <Accordian.Body>
                        <p>The team has set aside 25% of the supply to go towards staking rewards for loyal holders. The rewards accumulate on a block by
                          block basis. So a holder can claim their rewards at
                          anytime without penalty. The only cost would be gas so plan wisely for
                          when to claim to maximize profit.</p>
                      </Accordian.Body>
                    </Accordian.Item>
                  </Accordian>
                </div>
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="second">
            <div className="row gy-3 gx-5">
                <div className="col-lg-6">
                <Accordian  id="accordionToken1">
                    <Accordian.Item eventKey="0">
                      <Accordian.Header>What are the rewards?</Accordian.Header>
                      <Accordian.Body>
                      <p>We have set aside 25% of our token supply to reward
      our investors who stake their QTE tokens.
      Rewards are distributed block by block and based on
      number of tokens held and how many tokens are staked.</p>
                      </Accordian.Body>
                    </Accordian.Item>
                    <Accordian.Item eventKey="1">
                      <Accordian.Header>How do I claim my rewards?</Accordian.Header>
                      <Accordian.Body>
                       <p>To claim your rewards simply click the{" "}
      <a href="/dashboard">Claim Rewards</a> button and it will
      ask you to connect your wallet. Once connected you
      will see how many reward tokens you have accumulated.
      If you want to claim them just click the claim button
      within the app. Or you can let them continue to accrue
      over time. There is no penalty for not claiming
      immediately.</p>
                      </Accordian.Body>
                    </Accordian.Item>
                    <Accordian.Item eventKey="2">
                      <Accordian.Header>Is there a gas fee?</Accordian.Header>
                      <Accordian.Body>
                        <p>Yes, unfortunately to claim your token reward, you
      will incur a gas fee. We recommend claiming when gas
      is low or letting your rewards build up and claim less
      regularly to reduce your fees and improve profit
      margin.</p>
                      </Accordian.Body>
                    </Accordian.Item>
                  </Accordian>
                </div>
                <div className="col-lg-6">
                <Accordian  id="accordionToken2" >
                    <Accordian.Item eventKey="0">
                      <Accordian.Header>What if I sell before I claim?</Accordian.Header>
                      <Accordian.Body>
                      <p>If you have accrued rewards, they are yours no matter
      if you have sold or not. </p>
                      </Accordian.Body>
                    </Accordian.Item>
                    <Accordian.Item eventKey="1">
                      <Accordian.Header>Can I increase my rewards?</Accordian.Header>
                      <Accordian.Body>
                       <p>The best strategy is to gradually increase the
      percentage of the supply you hold, which will increase
      your rewards. You can also provide liquidity through our dashboard to increase your rewards.</p>
                      </Accordian.Body>
                    </Accordian.Item>
                    <Accordian.Item eventKey="2">
                      <Accordian.Header>Is there a transfer tax?</Accordian.Header>
                      <Accordian.Body>
                        <p> No, there is not a transfer tax.</p>
                      </Accordian.Body>
                    </Accordian.Item>
            
                  {/* <Accordian.Item eventKey="3">
                      <Accordian.Header>What are the Rewards for Liquidity?</Accordian.Header>
                      <Accordian.Body>
                        <p>We set aside 25% of our supply to distribute to holders who provide liquidity through our dashboard.</p>
                      </Accordian.Body>
                    </Accordian.Item> */}
                  </Accordian>
                </div>
              </div>
            </Tab.Pane>
          </Tab.Content>
            </Col>
          </Row>
            </Tab.Container>
          </div>
        </div>
    </section>
  );
}
